import { AlertBarNotifierBase } from "./alertbar-notifier-base";

export class AlertBarNotifier extends AlertBarNotifierBase {
    
}